/**
 * Upload Certificate Modal — built on TradeForm.
 *
 * Expects the modal HTML to already exist in the DOM (rendered by
 * snippets/upload-certificate-modal.liquid via trade-modal.liquid).
 *
 * Dispatches 'trade:certificate-uploaded' after successful upload.
 *
 * Exposes:
 *   window.TradeUploadCertificateModal.open()
 *   window.TradeUploadCertificateModal.close()
 */
(function () {
	const overlay = document.getElementById('upload-certificate-modal');
	if (!overlay) return;

	const maxCertificateFileSizeMb = 15;
	const maxCertificateFileSizeBytes = maxCertificateFileSizeMb * 1024 * 1024;

	const form = createTradeForm({
		overlay: overlay,
		submitBtn: 'submit-certificate-btn',
		errorContainer: 'certificate-error-message',
		errorText: 'certificate-error-text',
		resetBtnText: 'Upload Certificate',

		fields: {
			certNumber: {
				id: 'cert-number-input',
				required: 'Please enter a certificate number.',
			},
			state: {
				id: 'cert-state-select',
				required: 'Please select a state.',
			},
			expiryDate: {
				id: 'cert-expiry-input',
				required: 'Please select an expiration date.',
				validate: function (value) {
					const expiryDateObj = new Date(value);
					const today = new Date();
					today.setHours(0, 0, 0, 0);
					if (expiryDateObj <= today) {
						return 'Expiration date must be in the future.';
					}
				},
			},
			file: {
				id: 'cert-file-input',
				required: false,
			},
		},

		triggerSelector: '[data-open-upload-certificate]',

		submit: {
			url: window.tradeApiBase + '/companies/certificates',
			method: 'POST',
			source: 'TradeUploadCertificateModal.upload',
			loadingText: 'Uploading...',

			beforeSubmit: function () {
				const fileInput = document.getElementById('cert-file-input');
				const file = fileInput && fileInput.files ? fileInput.files[0] : null;

				if (!file) {
					return Promise.reject({ message: 'Please select a file to upload.' });
				}
				if (file.size > maxCertificateFileSizeBytes) {
					return Promise.reject({ message: 'File too large. Max size is ' + maxCertificateFileSizeMb + 'MB.' });
				}
				const allowedTypes = ['application/pdf', 'image/gif', 'image/jpeg', 'image/png'];
				if (allowedTypes.indexOf(file.type) === -1) {
					return Promise.reject({ message: 'Please upload a PDF, GIF, JPEG, or PNG file.' });
				}

				return new Promise(function (resolve, reject) {
					const reader = new FileReader();
					reader.onload = function () {
						resolve({ fileData: reader.result.split(',')[1], filename: file.name });
					};
					reader.onerror = function () {
						reject({ message: 'Failed to read the file. Please try again.' });
					};
					reader.readAsDataURL(file);
				});
			},

			buildPayload: function (values) {
				return {
					exemptionNumber: values.certNumber,
					region: values.state,
					country: 'US',
					signedDate: new Date().toISOString().split('T')[0],
					expirationDate: values.expiryDate,
					description: 'Resale certificate for ' + values.state,
					filename: values.filename,
					fileData: values.fileData,
				};
			},

			onSuccess: function (data, ctrl) {
				ctrl.modal.close();
				document.dispatchEvent(new CustomEvent('trade:certificate-uploaded'));
			},

			onError: function (err, ctrl) {
				console.error('Error uploading certificate:', err);
				ctrl.showError('Your certificate couldn\'t be uploaded. Please try again or reach out to our team.');
			},
		},
	});

	if (!form) return;

	/* ── public API ── */

	window.TradeUploadCertificateModal = {
		open: function () { form.modal.open(); },
		close: function () { form.modal.close(); },
	};
})();
